import { useEffect, useRef } from 'react';
import { useLayoutStore } from '../../lib/stores/LayoutStore';
/** Sets the topbar trail while mounted; clears it (null → path-generated trail) on unmount. Pass null to leave the default trail. */ export function useRecordBreadcrumbs(items) {
    const setBreadcrumbItems = useLayoutStore((s)=>s.setBreadcrumbItems);
    const latest = useRef(items);
    latest.current = items;
    const key = items ? JSON.stringify(items.map((i)=>[
            i.label,
            i.href ?? null
        ])) : '';
    // `key` (labels + hrefs) re-runs the effect; a fresh array of the same content does not.
    useEffect(()=>{
        if (!latest.current) return;
        setBreadcrumbItems(latest.current);
        return ()=>setBreadcrumbItems(null);
    }, [
        key,
        setBreadcrumbItems
    ]);
}
